import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, EnhancedAutocomplete, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { buildItemServiceSelectOptions, disabledItemServiceOptions, selectedNameOption } from './itemServiceSelect.utils';
export const GetItemServiceSelectTID = (parentTestId)=>getTestIds(parentTestId);
export function ItemServiceSelect(param) {
    let { rowIndex, selectedName, agreementOptions, outOfScopeTemplates, formatTemplateCost, onSelect, onClear, onCreateNew, error, helperText, testId } = param;
    const { t: addChargeTexts } = useLocaleKeys('components.billClientModal.addCharge');
    const { ItemServiceSelectTestIds } = useMemo(()=>GetItemServiceSelectTID(testId), [
        testId
    ]);
    const options = useMemo(()=>buildItemServiceSelectOptions({
            agreementOptions,
            outOfScopeTemplates,
            formatTemplateCost,
            inAgreementSectionLabel: addChargeTexts.inAgreementSection(),
            outOfScopeSectionLabel: addChargeTexts.outOfScopeSection()
        }), [
        agreementOptions,
        outOfScopeTemplates,
        formatTemplateCost,
        addChargeTexts
    ]);
    const disabledItems = useMemo(()=>disabledItemServiceOptions(agreementOptions), [
        agreementOptions
    ]);
    const selectedOption = useMemo(()=>{
        var _options_find;
        return selectedName ? (_options_find = options.find((option)=>option.name === selectedName)) !== null && _options_find !== void 0 ? _options_find : selectedNameOption(selectedName) : null;
    }, [
        options,
        selectedName
    ]);
    return /*#__PURE__*/ _jsx(EnhancedAutocomplete, {
        bi: {
            name: 'change_item'
        },
        testId: ItemServiceSelectTestIds.Root(),
        options: options,
        keyField: "id",
        labelField: "name",
        menuWidth: 350,
        size: "medium",
        selectedOption: selectedOption,
        disabledItems: disabledItems,
        error: error,
        helperText: helperText,
        emptySearchText: addChargeTexts.emptyState(),
        textFieldProps: {
            bi: {
                name: 'change_item_search'
            },
            placeholder: addChargeTexts.chooseItemPlaceholder(),
            minWidth: 160
        },
        itemRenderer: (option)=>/*#__PURE__*/ _jsxs(Column, {
                gap: 2,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "p",
                        ellipsis: true,
                        children: option.name
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "p",
                        skin: "secondary",
                        variant: "paragraph2",
                        ellipsis: true,
                        children: option.costString
                    })
                ]
            }),
        applyOptionChange: (option)=>{
            if (option === null || option === void 0 ? void 0 : option.selection) {
                onSelect(rowIndex, option.selection);
                return;
            }
            if (option == null) onClear(rowIndex);
        },
        newItemOption: {
            text: addChargeTexts.createNew(),
            onClick: async ()=>{
                onCreateNew(rowIndex);
            }
        }
    });
}
